import React, { PropsWithChildren } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { getRuntimeConfig } from '../../config/runtime-config'

export const InjectedStripeForm = (props: PropsWithChildren<any>) => {
    // Without a configured publishable key there is nothing to load; `Elements` accepts a
    // null instance and its children render without a live Stripe context.
    const stripePromise = React.useMemo(() => {
        const apiKey = getRuntimeConfig().STRIPE_API_KEY
        return apiKey ? loadStripe(apiKey) : Promise.resolve(null)
    }, [])

    return <Elements stripe={stripePromise}>{props.children}</Elements>
}
